<template>
  <div class="box pb-5">
    <h3 class="text-white p-3">订单总数量</h3>
    <div class="d-flex align-items-center justify-content-around">
      <div class="box-warp" v-for="item in infoList" :key="item.id">
      <div :id= item.id></div>
      <div class="percent" :style = "{color:item.color[0]}">{{item.percent}}%</div>
      <p class="text-white h4 text-center">{{item.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts');
  // 引入饼状图
  require('echarts/lib/chart/pie');

  export default {
    name: 'PercentagePie',
    computed: {
      ...mapState(['StoreChartLists']),
      infoList() {
        let total = this.StoreChartLists.sOrderNum,
          hotel = this.StoreChartLists.hOrderNum,
          homestay = this.StoreChartLists.hsOrderNum,
          scenic = this.StoreChartLists.vpOrderNum;
        let result1 = 0, result2 = 0, result3 = 0;
        if (total !== 0) {
          result1 = Math.round(hotel / total * 100);
          result2 = Math.round(homestay / total * 100);
          result3 = Math.round(scenic / total * 100);
        }
        return [
              {id:'pie_one',color:['#12B2CB','#0A7788'],percent:result1,name:'酒店',value:hotel,total:total},
              {id:'pie_two',color:['#6DA8EC','#4D76B8'],percent:result2,name:'民宿',value:homestay,total:total},
              {id:'pie_three',color:['#8F7CF9','#5947B5'],percent:result3,name:'景区',value:scenic,total:total},
        ]
      }
    },
    watch:{
      infoList: {
        handler(val) {
          this.initEchart(val[0]);
          this.initEchart(val[1]);
          this.initEchart(val[2]);
        },
        deep:true,
      }
    },
    methods: {
      initEchart(item) {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init($('#' + item.id).get(0));
          let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          series: [
            {
              name: '订单来源',
              type: 'pie',
              color:item.color,
              radius: ['63%', '70%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [
                {value: item.value, name: item.name},
                {value: item.total - item.value, name: '其他'},
              ]
            }
          ]
        };
        // 绘制图表
        myChart.setOption(option);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .box {
    width: 100%;
    background-color: #20283e;
    .box-warp{
      position: relative;
      top: 0;
      left: 0;
      #pie_one, #pie_two, #pie_three {
        width: 250px;
        height: 250px;
      }
      .percent{
        position: absolute;
        top: 100px;
        left: 98px;
        font-size: 36px;
      }
    }
  }
</style>
